import React, {useEffect, useState} from "react";
import {FormGroup, withStyles} from "@material-ui/core";
import i18n from "../../../i18n";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Button from "@material-ui/core/Button";
import FormSelect from "../../Form/FormSelect";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid/Grid";
import FormField from "../../Form/FormField";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import ReactDOM from "react-dom";

const formatGroupLabel = (data,classes) => (
   <div className={classes.group}>
        <span>{data.label}</span>
       {/*<span className={classes.groupBadge}>{data.options.length}</span>*/}
    </div>
);

const formatLabel = (type,option) => {
    let label = '';
    switch(type) {
        case 'week':
            label = 'KW ' + option;
            break;
        case 'month':
            label = i18n.get(
                'config.work_time.' +
                moment().month(option - 1 )
                    .format("MMMM")
                    .toLowerCase()
            )
            break;
    }
    return label;
}

const formatOptions = (type, key, options) => {
    if(options) {
        return options[key].map(option => {
            return {
                label: formatLabel(type,option),
                value: option,
                key: key,
            }
        })
    }
}

const formatGroupedOptions = (type, options) => {
    if(options) {
        return Object.keys(options).map( key => {
            return {
                label: key,
                options: options[key].map(option => {
                    return {
                        label: formatLabel(type,option),
                        value: option,
                        key: parseInt(key),
                    }
                }),
            }
        });
    }
}

const progress = () => {
    let wrapper = document.createElement('div');
    ReactDOM.render(
        <CircularProgress size={50} thickness={5} style={{'color': '#db2129'}} />,
        wrapper
    );
    let content = wrapper.firstChild;

    return swal({
        content: content,
        text:i18n.get('building.site_journal.please_have_patience'),
        buttons:false,
        closeOnClickOutside: false,
        closeOnEsc: false,
    });
}

const sendData = async(id,action,values) => {

    if(!values.start.length || !values.end.length) {
        return swal({
            text:i18n.get('building.site_journal.select_period'),
            icon:"warning",
            dangerMode: true,
            buttons: { confirm: { value: null, }, },
        });
    }

    let data = {
        action:action,
        filter:values
    };

    let url = `construction/${id}/site-journal/print`;

    if(action === 'preview') {
        await axios.post(url, data).then((res)=> {
            if(res.status === 204){
                swal({
                    text:i18n.get('building.site_journal.no_content'),
                    icon:"warning",
                    dangerMode: true
                });
            } else {
                let preview = window.open('','_blank');
                if(!preview) {
                    swal({
                        text:i18n.get('building.site_journal.popups_blocked'),
                        icon:"warning",
                        dangerMode: true
                    });
                } else {
                    preview.document.write(res.data);
                }

            }
        });
    }

    if(action === 'download') {
        /*** show circular progress icon while rendering pdf */
        progress();

        await axios.post(url, data ,{responseType: 'arraybuffer'})
            .then((res) => {
                if(res.status === 204){
                    swal({
                        text:i18n.get('building.site_journal.no_content'),
                        icon:"warning",
                        dangerMode: true
                    });
                }
                if(res.status === 200){
                    const file = new Blob(
                        [res.data],
                        {type: 'application/pdf'});
                    const fileURL = URL.createObjectURL(file);
                    const link = document.createElement('a');
                    link.href = fileURL
                    link.download = res.headers['custom-filename'];
                    link.click();
                    swal.close();
                    // only for testing: window.open(fileURL);
                }
            }).catch(() => {
                swal({
                    text:i18n.get('building.site_journal.creating_pdf_error'),
                    icon:"warning",
                    dangerMode: true
                });
                //console.error('error',error);
            });
    }
    return false;
}

const PrintDialog = (props) => {

    const {
        classes,
        open,
        handleClose,
        building,
    } = props;

    const filter = building && building.print_filter ? building.print_filter : null;

    const defaultValues = {
        shell: false,
        finishing: false,
        start: '',
        end: '',
        year: null,
        month:null,
        week:null,
        images:false,
        statistics:false,
    };

    const [values, setValues] = useState(defaultValues);
    const [shell, setShell] = useState(false);
    const [finishing, setFinishing] = useState(false);
    const [images, setImages] = useState(false);
    const [statistics, setStatistics] = useState(false);

    const changeShell = value => { setShell(value); setFieldValue('shell',value); }
    const changeFinishing = value => { setFinishing(value); setFieldValue('finishing',value); }
    const changeImages = value => { setImages(value); setFieldValue('images',value); }
    const changeStatistics = value => { setStatistics(value); setFieldValue('statistics',value); }

    const setFieldValue = (field,value) => {
        values[field] = value;
        setValues({...values});
    }

    const closeDialog = () => {
        setValues(defaultValues);
        handleClose();
    }

    const handleSubmit = e => {
        sendData( building.id, e.currentTarget.name, values ).then(res => {
            if(res) {
                closeDialog();
            }
        })
    }

    const handleChangeCheckbox = e => {
        switch(e.target.name) {
            case 'shell': changeShell(e.target.checked); break;
            case 'finishing': changeFinishing(e.target.checked); break;
            case 'images': changeImages(e.target.checked); break;
            case 'statistics': changeStatistics(e.target.checked); break;
        }
    }

    useEffect(() => {
        if(filter) {
            let shellPeriod = filter['shell_period'];
            let finishingPeriod = filter['finishing_period'];
            let start = null, end = null;
            if(shell && finishing){
                start = shellPeriod['first_date'];
                end = finishingPeriod['last_date'];
            } else {
                if(shell) {
                    start = shellPeriod['first_date'];
                    end = shellPeriod['last_date'];
                }
                if(finishing) {
                    start = finishingPeriod['first_date'];
                    end = finishingPeriod['last_date'];
                }
                if(shell || finishing) {
                    ['year','month','week']
                        .map(field => setFieldValue(field, defaultValues[field]));
                }
                if(!values.year){
                    ['start','end','year','month','week']
                        .map(field => setFieldValue(field, defaultValues[field]));
                }
            }
            start && setFieldValue('start', moment(start).format('YYYY-MM-DD') );
            end && setFieldValue('end', moment(end).format('YYYY-MM-DD') );
        }
    },[shell,finishing,values.year]);

    return (
        <Dialog open={open}
            onClose={closeDialog}
            disableBackdropClick={true}
            className={classes.dialog}
            fullWidth={true}
            maxWidth={'sm'}
            aria-labelledby="form-dialog-title">

            <DialogTitle id="form-dialog-title" className={classes.dialogTitle} disableTypography>
                <Typography variant="h6" color={"primary"}>
                    {i18n.get('building.site_journal.print_filter')}
                </Typography>
                <IconButton aria-label="close" className={classes.closeButton} onClick={closeDialog}>
                    <Icon>close</Icon>
                </IconButton>
                <div style={{fontSize:18, color:'#999999'}}>
                    {i18n.get('building.site_journal.self',{building: building && building.name  })}
                </div>
                <div style={{fontSize:11,color:'#999999'}}>
                    {i18n.get('building.site_journal.hints')}
                    <ul>
                        <li>{i18n.get('building.site_journal.hint_begin',{date: filter ? moment(filter.total_period.first_date ).format('DD.MM.YYYY') : ''})}</li>
                        <li>{i18n.get('building.site_journal.hint_end')}</li>
                    </ul>
                </div>
            </DialogTitle>

            <DialogContent className={classes.dialogContent}>

                <Grid spacing={8} container >

                    <Grid item xs={6}>
                        <FormHelperText>{i18n.get('site-journal.construction_phase')}</FormHelperText>
                        <FormGroup row>
                            <FormControlLabel
                                control={<Checkbox checked={shell} onChange={handleChangeCheckbox} color={'primary'} name="shell" />}
                                label={i18n.get('site-journal.shell')}
                            />
                            <FormControlLabel
                                control={<Checkbox checked={finishing} onChange={handleChangeCheckbox} color={'primary'} name="finishing" />}
                                label={i18n.get('site-journal.finishing')}
                            />
                        </FormGroup>
                        <Divider className={classes.checkBoxDivider}/>
                    </Grid>

                    <Grid item xs={6}>
                        <FormHelperText>{i18n.get('building.site_journal.reporting')}</FormHelperText>
                        <FormGroup row>
                            <FormControlLabel
                                control={<Checkbox checked={statistics} onChange={handleChangeCheckbox} color={'primary'} name="statistics" />}
                                label={i18n.get('building.site_journal.statistics_of_hours')}
                            />
                        </FormGroup>
                        <Divider className={classes.checkBoxDivider}/>
                    </Grid>

                    {/*<Grid item xs={6}>*/}
                    {/*    <FormHelperText>{i18n.get('building.site_journal.media')}</FormHelperText>*/}
                    {/*    <FormGroup row>*/}
                    {/*        <FormControlLabel*/}
                    {/*            control={<Checkbox checked={images} onChange={handleChangeCheckbox} color={'primary'} name="images" />}*/}
                    {/*            label={i18n.get('building.site_journal.embed_images')}*/}
                    {/*        />*/}
                    {/*    </FormGroup>*/}
                    {/*    <Divider className={classes.checkBoxDivider}/>*/}
                    {/*</Grid>*/}

                    <Grid item xs={6}>
                        <FormField
                            type="date"
                            name="start"
                            label={i18n.get('building.site_journal.start')}
                            InputLabelProps={{shrink: true}}
                            onChange={e => {
                                shell && changeShell(false);
                                finishing && changeFinishing(false);
                                setFieldValue('start',e.target.value);
                            }}
                            value={values.start}
                            inputProps={{
                                min: filter && filter['total_period']['first_date'],
                                max: values.end,
                            }}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <FormField
                            type="date"
                            name="end"
                            label={i18n.get('building.site_journal.end')}
                            InputLabelProps={{shrink: true}}
                            onChange={e => {
                                shell && changeShell(false);
                                finishing && changeFinishing(false);
                                setFieldValue('end',e.target.value);
                            }}
                            value={values.end}
                            inputProps={{
                                min: values.start,
                                max: moment().format('YYYY-MM-DD'),
                            }}
                        />
                    </Grid>

                    <Grid item xs={4}>
                        <FormSelect
                            type="text"
                            name="year"
                            label={i18n.get('building.site_journal.year')}
                            onChange={option => {
                                setFieldValue('year', option ? option.value : null);
                                setFieldValue('start',option ? option.value + '-01-01' : null);
                                setFieldValue('end',option ? option.value + '-12-31' : null);
                                shell && changeShell(false);
                                finishing && changeFinishing(false);
                                if(!option) {
                                    ['month','week','start','end']
                                        .map(field => setFieldValue(field, defaultValues[field]))
                                }
                            }}
                            options={
                                filter
                                    ? filter.years.map(year => ({label:year, value:year}) )
                                    : ['']
                            }
                            value={values.year}
                            isClearable={true}
                            autoComplete={"off"}
                        />
                    </Grid>

                    <Grid item xs={4}>
                        <FormSelect
                            type="text"
                            name="month"
                            label={i18n.get('building.site_journal.month')}
                            onChange={option => {
                                setFieldValue('year', option ? parseInt(option.key) : values.year);
                                setFieldValue('month', option ? option.value : null);
                                setFieldValue('start',option
                                    ? option.key + '-' + (option.value + '').padStart(2, '0') + '-01'
                                    : ''
                                );
                                setFieldValue('end',option
                                    ? moment().year(option.key).month(option.value - 1 ).endOf('month').format('YYYY-MM-DD')
                                    : ''
                                );
                                shell && changeShell(false);
                                finishing && changeFinishing(false);
                                if(option) {
                                    setFieldValue('week', null);
                                } else {
                                    if(values.year) {
                                        setFieldValue('start', values.year + '-01-01');
                                        setFieldValue('end',values.year + '-12-31');
                                    } else {
                                        ['start','end']
                                            .map(field => setFieldValue(field, defaultValues[field]))
                                    }
                                }
                            }}
                            options={
                                filter ? values.year
                                    ? formatOptions('month',values.year, filter.months_of_year)
                                    : formatGroupedOptions('month', filter.months_of_year)
                                : ['']
                            }
                            formatGroupLabel={data => formatGroupLabel(data,classes)}
                            value={values.month}
                            isClearable={true}
                            autoComplete={"off"}
                        />
                    </Grid>

                    <Grid item xs={4}>
                        <FormSelect
                            type="text"
                            name="week"
                            label={i18n.get('building.site_journal.week_of_year')}
                            onChange={option => {
                                setFieldValue('year', option ? parseInt(option.key) : null);
                                setFieldValue('week', option ? option.value : null);
                                setFieldValue('start', option
                                    ? moment().year(option.key)
                                        .isoWeek(option.value)
                                        .day(1)
                                        .format('YYYY-MM-DD')
                                    : '');
                                setFieldValue('end', option
                                    ? moment().year(option.key)
                                        .isoWeek(option.value)
                                        .day(7)
                                        .format('YYYY-MM-DD')
                                    : '');
                                shell && changeShell(false);
                                finishing && changeFinishing(false);
                                if(option) {
                                    setFieldValue('month', null);
                                } else {
                                    ['start','end']
                                        .map(field => setFieldValue(field, defaultValues[field]))
                                }
                            }}
                            options={
                                filter ? values.year
                                    ? formatOptions('week',values.year, filter.weeks_of_year)
                                    : formatGroupedOptions('week', filter.weeks_of_year)
                                    : ['']
                            }
                            value={values.week}
                            isClearable={true}
                            autoComplete={"off"}
                        />
                    </Grid>

                </Grid>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button
                    component={'a'}
                    variant={'contained'}
                    color={'primary'}
                    size={'small'}
                    name={'preview'}
                    onClick={handleSubmit}
                >
                    {i18n.get('building.actions.print_preview')}
                </Button>
                <Button
                    component={'a'}
                    variant={'contained'}
                    color={'primary'}
                    size={'small'}
                    style={{marginLeft:10}}
                    name={'download'}
                    onClick={handleSubmit}
                    disabled={statistics}
                >
                    {i18n.get('building.actions.download_pdf')}
                </Button>
            </DialogActions>

        </Dialog>
    );
}

const styles = theme => ({
    dialog: {
        minHeight:700,
    },
    dialogTitle: {
        color: theme.colors.primary,
    },
    dialogContent: {
        overflow:'visible',
    },
    dialogActions: {
        paddingRight: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing.unit * 1.2,
        top: theme.spacing.unit * 2,
    },
    checkBoxDivider: {
        marginTop: '-0.7rem',
        marginBottom:0,
        backgroundColor:'rgba(0, 0, 0, 0.4)',
    },
    group: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    groupBadge: {
        backgroundColor: '#EBECF0',
        borderRadius: '2em',
        color: '#172B4D',
        display: 'inline-block',
        fontSize: 12,
        fontWeight: 'normal',
        lineHeight: '1',
        minWidth: 1,
        padding: '0.16666666666667em 0.5em',
        textAlign: 'center',
    }
});

export default withStyles(styles)(PrintDialog);
